export const DASHBOARD_TIMEFRAME_PRESETS = [
  'today',
  'yesterday',
  'last-7-days',
  'last-30-days',
  'this-month',
  'last-month',
  'this-year',
  'last-year',
  'custom',
] as const;

export const DASHBOARD_CHART_MODES = [
  'totals',
  'weekday-average',
  'hourly-average',
] as const;

export const QUICK_FEEDBACK_SENTIMENTS = [
  'happy',
  'neutral',
  'unhappy',
] as const;

export const QUICK_FEEDBACK_MESSAGES_PAGE_SIZE = 50;

export const DEFAULT_DASHBOARD_TIMEFRAME_PRESET = 'last-30-days';

export const MAX_CUSTOM_DASHBOARD_RANGE_DAYS = 366;
